import { Bank } from '@core/model/domain/bank';
import { Result } from '@core/model/framework/Result/Result';
import { GetBanks } from '@core/usecase/getBanks';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';

export class BankChoiceVM {
  constructor(
    private getBanks: GetBanks,
    private tracker: TrackerService,
    private storeService: StoreService
  ) {}
  async onInit(): Promise<Bank[]> {
    this.tracker.trackPage({ taggingPage: 'BANK_CHOICE' });

    const banksStored = this.storeService.getVariable('BANKS');
    const areBanksAlreadyStored = banksStored != null;

    if (areBanksAlreadyStored) {
      return banksStored;
    }

    const banks = Result.unwrap(await this.getBanks.execute());
    this.storeService.setVariable('BANKS', banks);
    return banks;
  }

  getTopBanksAndOtherBanks(allBanks: Bank[]): { topBanks: Bank[]; otherBanks: Bank[] } {
    const numberOfPopularBanksDisplayed = 6;

    const mostPopularBankNamesOrdered = [
      "Caisse d'Épargne Particuliers",
      'Banque Populaire',
      'Crédit Agricole',
      'La Banque Postale',
      'Société Générale',
      'BoursoBank',
      'LCL',
      'BNP Paribas',
      'CIC',
      'Crédit Mutuel',
      'Hello bank!',
      'Banque Européenne Crédit Mutuel',
      'Crédit Mutuel de Bretagne',
      'Fortuneo',
      'Monabanq',
      'Crédit Mutuel du Sud Ouest',
      'BforBank',
      'Carrefour Banque',
    ];

    const popularBanksAvailable = this.filterAndSortBanks(allBanks, mostPopularBankNamesOrdered);
    const topBanks = popularBanksAvailable.slice(0, numberOfPopularBanksDisplayed);
    const otherBanks = allBanks.filter((bank) => !topBanks.includes(bank));

    return {
      topBanks,
      otherBanks,
    };
  }

  private filterAndSortBanks(banks: Bank[], namesOfBankToRetrieve: string[]): Bank[] {
    return banks
      .filter((bank) => namesOfBankToRetrieve.includes(bank.name))
      .sort((a, b) => {
        const indexA = namesOfBankToRetrieve.indexOf(a.name);
        const indexB = namesOfBankToRetrieve.indexOf(b.name);
        return indexA - indexB;
      });
  }
}
